"use client";

import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { UseCase } from "@/types/scripts";
import { DirectorySetupSection } from "./DirectorySetupSection";
import { OnboardingStepHeader } from "./OnboardingStepHeader";
import { StepFooter } from "./StepFooter";

interface DirectorySetupStepProps {
  readonly onBack?: () => void;
  readonly onNext: () => void;
  /** Called with the ID of each use case created during directory setup. */
  readonly onUseCaseCreated?: (useCaseId: string) => void;
}

export function DirectorySetupStep({ onBack, onNext, onUseCaseCreated }: DirectorySetupStepProps) {
  const { t } = useTranslation("onboarding");

  const handleUseCaseCreated = useCallback(
    (useCase: UseCase) => {
      onUseCaseCreated?.(useCase.id);
    },
    [onUseCaseCreated]
  );

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 overflow-y-auto p-8">
        <div className="w-full max-w-4xl mx-auto space-y-6">
          <OnboardingStepHeader
            title={t("directorySetup.title")}
            description={t("directorySetup.subtitle")}
          />

          <DirectorySetupSection onUseCaseCreated={handleUseCaseCreated} />
        </div>
      </div>

      {/* Footer */}
      <StepFooter onBack={onBack} onSkip={onNext} onNext={onNext} bgClassName="bg-50" />
    </div>
  );
}
